import { render, staticRenderFns } from "./OzMenuRows.vue?vue&type=template&id=7c86a29e&"
import script from "./OzMenuRows.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OzMenuRows.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports